export default {"src":"/_next/static/media/Ollie_Site_Icons_working_final_ResearchingVegan.78cc2e74.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};